<template>
    <div class="infor fl">
        <all-header
            :label="lable"
            :ischage="ischage"
            :sublabel="sublabel"
            :subtitle="subtitle"
            @getvalue="getvalue"></all-header>
        
        <div  ref="pdf">
            <div>
                <el-table
                    :data="logs"
                    :header-cell-style="{ background: '#FEF8EF', color: '#7C828A','text-align':'center' }"
                    style="width: 100%; margin-top: 30px" :cell-style="{'text-align':'center'}">
                    <el-table-column :show-overflow-tooltip="true" prop="no" label="序号" min-width="60"></el-table-column>
                    <el-table-column :show-overflow-tooltip="true" prop="dept" label="所属部门" min-width="110"></el-table-column>
                    <!-- 处理人列：企业端隐藏 -->
                    <el-table-column :show-overflow-tooltip="true" prop="action" label="动作" min-width="80"></el-table-column>
                    <el-table-column :show-overflow-tooltip="true" prop="step" label="当前节点" min-width="130"></el-table-column>
                    <el-table-column :show-overflow-tooltip="true" prop="checkedAt" label="处理时间" min-width="140"></el-table-column>
                    <el-table-column :show-overflow-tooltip="true" label="处理意见" min-width="160">
                        <template slot-scope="scope">
                            <div>{{scope.row.checkedStatus}}</div>
                            <div v-if="scope.row.modify_deadline" class="log-hint log-hint--warning">修订截止：{{ scope.row.modify_deadline }}</div>
                        </template>
                    </el-table-column>
                    <el-table-column :show-overflow-tooltip="true" prop="nstep" label="下一个节点" min-width="130"></el-table-column>
                </el-table>
            </div>
           
        </div>
      <el-dialog title="温馨提示" :visible.sync="dialogVisible" width="474px" :before-close="handleClose" >
        <div class="yellow-box" style="font-size:18px;text-align:left">
            {{checked_remark}}
        </div>
      </el-dialog>
      <el-dialog
        title="修改申请详情"
        :visible.sync="modifyDetailVisible"
        width="720px"
        :before-close="handleModifyDetailClose"
      >
        <div class="modify-detail" v-if="modifyDetail">
          <div class="modify-detail__row">
            <div class="modify-detail__label">联系人</div>
            <div class="modify-detail__value">{{ modifyDetail.contact_name || '—' }}</div>
          </div>
          <div class="modify-detail__row">
            <div class="modify-detail__label">联系电话</div>
            <div class="modify-detail__value">{{ modifyDetail.contact_phone || '—' }}</div>
          </div>
          <div class="modify-detail__row modify-detail__row--top">
            <div class="modify-detail__label">申请附件</div>
            <div class="modify-detail__value modify-detail__files">
              <template v-if="modifyFileList.length">
                <a
                  v-for="(file, index) in modifyFileList"
                  :key="file.url || index"
                  :href="file.url"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="modify-detail__file"
                >
                  {{ file.name }}
                </a>
              </template>
              <span v-else>—</span>
            </div>
          </div>
          <div class="modify-detail__row modify-detail__row--top">
            <div class="modify-detail__label">申请说明</div>
            <div class="modify-detail__value modify-detail__reason">{{ modifyDetail.reason || '—' }}</div>
          </div>
        </div>
      </el-dialog>
      
      
    </div>
    
</template>

<script>
import Lineconbgtir from './Modal/Line'
import Downinpu from '@/components/Modal/Downinpu'
import Pagetion from '@/components/Modal/Pagetion'
import AllHeader from '@/components/Modal/AllHeader'
import {
    checkedlogs
} from '../utils/api.js'
export default {
    name: 'Gflogs',
    components: {
        AllHeader,
        Pagetion,
        // Steps,
        Lineconbgtir,
        Downinpu
    },
    data() {
        return {
            dialogUploadVisible:false,
            projectname:'',//项目名称
            isfile_urls:null,//利用file_urls判断绿色施工是否第二次上传资料
            content: {},//表单数据
            isdownload: false,//需要下载得页面是否显示
            total: 1,
            sublabel: '返回记录列表',
            subtitle: '',
            ischage: true,
            lable: '',
            logs: [],
            
            supplementName:'',//补充材料名词
            currentSupplementId:0,
            currentId:0,
            currentSubTitle:'',
            activeProject: {},
            is_show_score:0,
            projectid:0,
            mid:0,
            logid:0 ,
            awardid:0,
            award_batch_id:0,
            award_title:'',
            dialogVisible:false,
            checked_remark:'',
            modifyDetailVisible: false,
            modifyDetail: null,
            smsFailureContactTip: '如通知失败非企业停机、空号、暂停服务、关机、不在服务区的原因造成，请及时联系告知评审办公室。',
        }
    },
    computed: {
        modifyFileList() {
            const raw = this.modifyDetail && this.modifyDetail.file_urls
            if (!raw) return []
            let urls = raw
            if (typeof raw === 'string') {
                try {
                    urls = JSON.parse(raw)
                } catch (e) {
                    urls = raw ? [raw] : []
                }
            }
            if (!Array.isArray(urls)) {
                urls = urls ? [urls] : []
            }
            return urls
                .filter(Boolean)
                .map((url, index) => {
                    const cleanUrl = String(url)
                    const parts = cleanUrl.split('/')
                    return {
                        url: cleanUrl,
                        name: decodeURIComponent(parts[parts.length - 1] || `附件${index + 1}`),
                    }
                })
        },
    },
    mounted() {
        this.lable = this.resolveAwardTitle(this.$route.query.title, this.$route.query.awardid)
        this.logid = this.$route.query.logid;
        this.awardid = this.$route.query.awardid;
        this.award_title = this.resolveAwardTitle(this.$route.query.title, this.$route.query.awardid)
        this.award_batch_id = this.$route.query.award_batch_id;
        this.token = 'Bearer ' + localStorage.getItem('TOKEN')
        this.subtitle = '审核日志' 
        this.initList()
    },
    methods: {
        resolveAwardTitle(title, awardId) {
            if (title && title !== '审核日志') return title
            const titleMap = {
                13: '建筑与市政工程绿色施工评价',
                17: '工程建设质量管理小组竞赛活动',
                21: '贵州省工程建设工法评定',
            }
            return titleMap[Number(awardId)] || title || '申报记录'
        },
        handleClose(done) {
          done();
        },
        handleModifyDetailClose(done) {
            this.modifyDetailVisible = false
            this.modifyDetail = null
            if (typeof done === 'function') done()
        },
         toOpinion(id,award_log_id){
	        this.$router.push(`/ginfo?id=${id}&aid=${award_log_id}`)
	    },
        //奖项列表
        async initList() {
            let res = await checkedlogs(this.logid);
            console.log('res',res)
            this.logs = (res || []).map(this.normalizeEnterpriseLog).map((row) => {
                const next = Object.assign({}, row)
                delete next.checker
                delete next.user_name
                delete next.handler
                return next
            })
        },
        normalizeEnterpriseLog(row) {
            const map = {
                submit: '企业提交',
                withdraw: '企业自主撤回修改',
                admin_return: '管理员退回',
                resubmit: '企业重新提交',
                auto_submit: '超期自动提交',
                expert_return: '专家退回',
                timeout_terminated: '逾期终止',
                initial_review: '初审',
                leader_review: '组长中审',
                return_initial: '组长退回初审',
                final_review: '管理员终审',
            }
            const action = row.action_type || row.log_type || row.event_type
            if(action && map[action]){
                return Object.assign({}, row, {
                    step: row.step || map[action],
                    checkedStatus: row.checkedStatus || row.checked_status_text || map[action],
                    checkedRemark: row.checkedRemark || row.reject_reason || row.remark || row.reason || '',
                })
            }
            return row
        },
       
        //获取上传数组
        setUrls(fileList) {
            let urls = []
            fileList.map((item) => {
                urls.push(item.response.data.host + item.response.data.url)
            })
            this.file_urls = urls
            console.log(this.file_urls)
        },
        handleError(err, file, fileList) {
            this.showErr = true
            let that = this
            setTimeout(function () {
                that.showErr = false
                console.log(that.showErr)
            }, 2000)
            // console.log(this.showErr);
        },
        //现在去修改
        now_modify() {
            this.$router.push(`/form?title=${this.award_title}&id=${this.awardid}&r=${this.logid}&award_batch_id=${this.award_batch_id}`)
        },
        getvalue() {
            this.$router.push(`/member/Declar_record?name=申报记录&baid=${this.awardid}&btitle=${this.award_title}`)
            //history.go(-1);
            //awardrecordList(page,award_id,title
        },
        showremark(remark){
            console.log('remark',remark)
            this.checked_remark = remark;
            this.dialogVisible = true;
            console.log('remark',this.dialogVisible)
        },
        formatNeedModifyFields(fields) {
            if (!fields) return ''
            if (Array.isArray(fields)) {
                return fields.join('、')
            }
            if (typeof fields === 'object') {
                return Object.keys(fields).map((key) => {
                    const value = fields[key]
                    if (typeof value === 'string') return value
                    return value && value.name ? value.name : key
                }).join('、')
            }
            return String(fields)
        }
    }
}
</script>

<style>
.el-table .cell {
  width: max-content;
}
.action-buttons {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}
.modify-detail__row {
  display: flex;
  align-items: stretch;
}
.modify-detail__row + .modify-detail__row {
  margin-top: 12px;
}
.modify-detail__row--top .modify-detail__label,
.modify-detail__row--top .modify-detail__value {
  align-items: flex-start;
}
.modify-detail__label {
  width: 120px;
  min-width: 120px;
  padding: 12px 16px;
  background: #f5f8fb;
  color: #262626;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
}
.modify-detail__value {
  flex: 1;
  min-height: 48px;
  padding: 12px 16px;
  background: #fbfdff;
  color: #262626;
  line-height: 24px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  word-break: break-all;
}
.modify-detail__files {
  flex-direction: column;
  gap: 8px;
}
.modify-detail__file {
  color: #194abe;
  text-decoration: underline;
}
.modify-detail__reason {
  white-space: pre-wrap;
}
.log-hint {
  margin-top: 4px;
  color: #606266;
  white-space: normal;
}
.log-hint--warning {
  color: #e6a23c;
}
.log-hint--danger {
  color: #f56c6c;
}
</style>
<style lang="less" scoped>
.applybut {
  padding: 6px 15px;
}
/deep/.block-title {
  border-left: 3px solid #194abe !important;
}
/deep/.el-upload-list{
  display: flex;
  flex-direction: column;
  align-self: flex-start;
  text-align: start;
  height: auto;
}

.textarea {
  width: 382px;
  // height: 92px;
  background: #ffffff;
  border: 1px solid #bdc3cb;
  opacity: 1;
  border-radius: 4px;
}

.block-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin: 20px 0;

  &-item {
    width: 370px;
    background: #ffffff;
    border: 1px dashed #c8cdd5;
    padding: 24px 25px;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    margin-bottom: 21px;
    position: relative;
    &-r-t {
      position: absolute;
      top: 0;
      right: 0;
      width: 73px;
      height: 27px;
      background: #f5f9fb;
      opacity: 1;
      border-radius: 0px 0px 0px 80px;
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      line-height: 27px;
      color: #c6c9ce;
      padding-left: 10px;
      box-sizing: border-box;
    }
    &-box {
      display: flex;
      flex-direction: column;
      justify-content: space-evenly;
      align-items: flex-start;
      &-t {
        width: 244px;
        color: #0c0d0f;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        text-align: justify;
        font-size: 20px;
        font-family: Source Han Sans CN;
        font-weight: 400;
      }
      &-dtae {
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        line-height: 26px;
        color: #194abe;
      }
      &-startend {
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        line-height: 26px;
        color: #7c828a;
          margin-top:10px;
      }
      &-b {
        width: 91px;
        height: 32px;
        background: #ffffff;
        border: 1px solid #194abe;
        color: #194abe;
        opacity: 1;
        border-radius: 6px;
        text-align: center;
        line-height: 32px;
        font-size: 14px;
        cursor: pointer;
      }

      &-b-d {
        background: #ffffff !important;
        border: 1px solid #d4dbdd !important;
        color: #c8cdd5 !important;
      }

      &-b-s {
        background: #d4dbdd !important;
        border: 1px solid #d4dbdd !important;
        color: #ffffff !important;
      }
    }
  }
}

.margin-bottom-40 {
  margin-bottom: 40px;
}

.infor {
  padding-bottom: 40px;
  min-height: 800px;
  margin-bottom: 34px;
  position: relative;
}

.upload-demo {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}
.upload-demo2{
    justify-content: flex-start;
    align-items: flex-start;
    width:480px;
}
.uploadheader {
  height: 60px;
  width: 100%;
  display: flex;
  align-items: center;

  span {
    margin-right: 10px;
    color: #71767c;
  }
}

.margin-top-40 {
  margin-top: 40px;
}

.block-solid {
  width: 100%;
  height: 2px;
  background-color: #e51725;
  margin-top: 30px;
}

.shenhjrkr {
  margin: 71px 0 100px 0;

  img {
    width: 120px;
  }
}

.stepContainer {
  width: 100%;
  height: 160px;
  background-color: #f6f6f6;
  margin: 20px 0;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  overflow: hidden;

  .stepcone {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;

    .stepItem {
      width: 50px;
      height: 50px;
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 50%;
      background-color: #9fa5ae;
      border: 1px solid #9fa5ae;
      font-size: 32px;
      font-weight: 900;
      color: #c8cdd5;
      z-index: 999;

      .downpng {
        position: absolute;
        top: -20px;
        width: 20px;
        height: auto;
      }
    }

    img {
      width: 27px;
      height: auto;
    }

    .isactibe {
      color: white;
      // border: 1px solid #9FA5AE;
      // background-color: #9FA5AE;
    }

    .stponce {
      color: #194abe;
      border: 1px solid #194abe;
      background-color: white;
    }

    .error {
      color: #e51725;
      border: 1px solid #e51725;
      background-color: white;
    }

    .stepTitle {
      font-size: 18px;
      color: #c8cdd5;
      margin-top: 10px;
    }

    .successtitle {
      color: #0c0d0f;
    }

    .stpotitle {
      color: #194abe;
    }

    .erroritem {
      color: #e51725;
    }

    .line {
      width: 350%;
      flex: 1;
      flex-shrink: 0;
      height: 2px;
      border-bottom: 1px dashed #d4dbdd;
      position: absolute;
      top: 25px;
      left: 85%;
    }
  }
}
.block-addr {
  display: inline-block;
  padding: 13px 32px;
  background-color: #fff7e8;
  font-size: 14px;
  margin-top: 31px;
  .span-l {
    color: #9fa5ae;
  }
  .span-r {
    color: #194abe;
  }
}
.form_1 .form_box_content .form_title{
    box-sizing: border-box;
    text-align: start;
    display: flex;
    align-items: center;
}
.my_form2, .my_form{
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    overflow: visible;
    align-items: stretch;
}
.my_form2 .form_title,  .my_form .form_title{
    background: #eaf0f6;
    width: 129px;
    min-width: 129px;
    height: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 20px;
    padding: 6px;
    box-sizing: border-box;
    color: #0c0d0f;
}
.my_form2 .form_long,.my_form .form_long{
    width: 700px;
    padding: 0 6px;
    background: #f5f8fb;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
}
.my_form2 .form_long input, .my_form .form_long input{
    width: 488px;
    height: 36px;
    background: #fff;
    border: 1px solid #bdc3cb;
    opacity: 1;
    border-radius: 4px;
    padding: 0 15px;
    box-sizing: border-box;
}
.my_form2 .form_title {
    background: #f5f8fb;
}
.my_form2 .form_long{
    background: #fbfdff;
}

</style>
